import React from "react"
import { batch } from "@preact/signals-react"

import { AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { mainSite, sites } from "@signals"


export default function MainSitesAutocomplete({ ...props }) {
	return <AppSitesAutocomplete
		multiple={false}
		label="Main sites"
		placeholder="All main sites"
		value={mainSite.value}
		onChange={e => batch(() => {
			mainSite.value = e.target.value
			sites.value = Array.isArray(sites.value) ? sites.value.filter(op => e.target.value !== op) : (sites.value === e.target.value ? null : sites.value)
		})}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/sites`}
		{...props}
	/>
}